import * as React from 'react';

interface QuickSelectRefundButtonProps {
  label: React.ReactNode;
  checked: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

export const QuickSelectRefundButton = ({
  label,
  checked,
  isDisabled = false,
  onClick,
}: QuickSelectRefundButtonProps) => {
  return (
    <label
      className={`flex justify-center items-center gap-[3px] bg-secondary border rounded-[6px] px-[6px] py-[3px] ${
        isDisabled ? 'border-lightGray text-lightGray' : 'border-black text-black cursor-pointer'
      }`}
    >
      <input
        type="checkbox"
        checked={checked && !isDisabled}
        disabled={isDisabled}
        onChange={onClick}
        className="accent-anchor w-4 h-4"
      />
      {label}
    </label>
  );
};
